import kingsCodersAnswers from './answers.js';

function whoAmI(answers) {
    let scores = [
        {name: 'bart', score: 0, maxScore: 23},
        {name: 'ricardo', score: 0, maxScore: 29},
        {name: 'nico', score: 0, maxScore: 31},
        {name: 'jeffrey', score: 0, maxScore: 27},
        {name: 'maarten', score: 0, maxScore: 29},
        {name: 'martijn', score: 0, maxScore: 28},
        {name: 'koen', score: 0, maxScore: 33},
        {name: 'jonathan', score: 0, maxScore: 29},
        {name: 'patrick', score: 0, maxScore: 23},
        {name: 'dennis', score: 0, maxScore: 32},
        {name: 'jimmy', score: 0, maxScore: 29},
        {name: 'franklin', score: 0, maxScore: 28},
    ];
    const names = Object.keys(kingsCodersAnswers);

    for (let answerIndex = 0; answerIndex < answers.length; answerIndex++) {
        if (answers.hasOwnProperty(answerIndex)) {
            for (let nameIndex = 0; nameIndex < names.length; nameIndex++) {
                if (names.hasOwnProperty(nameIndex)) {
                    scores[nameIndex]['score'] += kingsCodersAnswers[names[nameIndex]][answerIndex][answers[answerIndex]];
                }
            }
        }
    }

    scores = scores.map((score) => {
        score.percentage = Math.ceil(score.score / score.maxScore * 100);

        return score;
    });

    return scores.sort((a, b) => {
        return a.percentage - b.percentage;
    }).reverse();
}

export {
    whoAmI,
};
